export var PICKER_OPT_SELECTED = 'picker-opt-selected';
export var DECELERATION_FRICTION = 0.97;
export var FRAME_MS = (1000 / 60);
export var MAX_PICKER_SPEED = 60;
//# sourceMappingURL=picker-options.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ionic-angular/components/picker/picker-options.js
// module id = 413
// module chunks = 20